import React, { useState } from 'react';
import { api } from '../api';

export default function SetPasswordPage({ onDone }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (password.length < 4) {
      setError('La contraseña debe tener al menos 4 caracteres');
      return;
    }
    if (password !== confirm) {
      setError('Las dos contraseñas no coinciden');
      return;
    }

    setSaving(true);
    try {
      await api.changePassword(password);
      onDone();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <span style={styles.emoji}>🔑</span>
        <h2 style={styles.title}>Crea tu contraseña</h2>
        <p style={styles.subtitle}>
          Es tu primera vez aquí. Elige una contraseña personal que solo tú conozcas.
        </p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div>
            <label className="label">Nueva contraseña</label>
            <input
              className="input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              autoFocus
            />
          </div>

          <div>
            <label className="label">Repite la contraseña</label>
            <input
              className="input"
              type="password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              placeholder="••••••••"
            />
          </div>

          {error && <p className="error-msg">⚠ {error}</p>}

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', padding: '0.8rem', fontSize: '1rem' }}
            disabled={saving}
          >
            {saving ? 'Guardando...' : 'Guardar y continuar ✨'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
    background: 'radial-gradient(ellipse at top, #2a1060 0%, #0f0720 60%)',
  },
  container: {
    width: '100%',
    maxWidth: '380px',
    background: 'var(--bg-card)',
    border: '1px solid var(--border)',
    borderRadius: '16px',
    padding: '2rem',
    textAlign: 'center',
    boxShadow: '0 8px 48px rgba(0,0,0,0.5)',
  },
  emoji: { fontSize: '2.5rem', display: 'block', marginBottom: '0.5rem' },
  title: { color: 'var(--gold)', fontSize: '1.4rem', fontFamily: 'var(--font-display)', marginBottom: '0.5rem' },
  subtitle: { color: 'var(--text-muted)', fontSize: '0.88rem', marginBottom: '1.5rem', lineHeight: 1.5 },
  form: { display: 'flex', flexDirection: 'column', gap: '1rem', textAlign: 'left' },
};
